export default {
  index: [
    {
      path: '/Report',
      component: resolve => require(['./ReportIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/Report/_router.js